import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import {
  fetchApprovedRoleAssignments,
  checkPermissionFromAssignments,
  getPermissionsFromAssignments,
  type PermissionLocation,
  type RoleAssignmentWithPermissions,
  type ScopeLevel,
} from '@/lib/permissions';

export type { PermissionLocation, RoleAssignmentWithPermissions, ScopeLevel };
export { checkPermissionFromAssignments, getPermissionsFromAssignments };

export const useUserRoleAssignments = () => {
  const { user, currentTenantId } = useAuth();

  return useQuery({
    queryKey: ['user-role-assignments', user?.id, currentTenantId],
    queryFn: async (): Promise<RoleAssignmentWithPermissions[]> => {
      if (!user || !currentTenantId) return [];
      return fetchApprovedRoleAssignments(user.id, currentTenantId);
    },
    enabled: !!user && !!currentTenantId,
    staleTime: 60 * 1000,
  });
};
